import React from 'react';
import RoomLayout from './components/RoomLayout';

function App() {
  return (
    <div className="App">
      <RoomLayout />
    </div>
  );
}

export default App;